module.exports = __webpack_public_path__ + "static/media/bg_oceania.52f7c5b7.jpg";